"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomSelectItem = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _CheckBox = require("../CheckBox");

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var CustomSelectItem = function CustomSelectItem(_ref) {
  var option = _ref.option,
      _ref$activeFilters = _ref.activeFilters,
      activeFilters = _ref$activeFilters === void 0 ? {} : _ref$activeFilters,
      parameterArray = _ref.parameterArray,
      globalFilters = _ref.globalFilters,
      setActiveFilters = _ref.setActiveFilters,
      setParameterArray = _ref.setParameterArray,
      className = _ref.className,
      _ref$route = _ref.route,
      route = _ref$route === void 0 ? "" : _ref$route,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "" : _ref$id;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showSubOptions = _useState2[0],
      setShowSubOptions = _useState2[1];

  var filterRoute = route;

  var returnFilterId = function returnFilterId(object) {
    var subOptions = object.subOptions,
        id = object.id;
    if (subOptions) return subOptions.map(returnFilterId);else return id;
  };

  var oneDimensionArray = function oneDimensionArray(arr) {
    var array = [];
    arr.forEach(function (element) {
      if ((0, _typeof2.default)(element) === "object") array.push.apply(array, (0, _toConsumableArray2.default)(oneDimensionArray(element)));else array.push(element);
    });
    return array;
  };

  var setFilter = function setFilter(object) {
    var newObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var subOptions = object.subOptions;

    if (subOptions) {
      subOptions.forEach(function (option) {
        newObject[option.name] = setFilter(option);
      });
      return newObject;
    } else return newObject[object.name] = 1;
  };

  var createFilter = function createFilter(rout, option, filters) {
    var levelsArray = rout.includes("|") ? rout.split("|").reverse() : [rout];

    if (levelsArray.length === 1) {
      return (0, _defineProperty2.default)({}, levelsArray[0], setFilter(option));
    } else if (levelsArray.length === 2) {
      var newObject = {};
      newObject[levelsArray[1]] = (0, _objectSpread2.default)({}, filters);
      newObject[levelsArray[1]][levelsArray[0]] = (0, _objectSpread2.default)({}, setFilter(option));
      return (0, _objectSpread2.default)({}, newObject);
    } else if (levelsArray.length === 3) {
      var _newObject = globalFilters;

      if (_newObject[levelsArray[2]]) {
        _newObject[levelsArray[2]][levelsArray[1]] = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _newObject[levelsArray[2]][levelsArray[1]]), filters);
      } else {
        _newObject = (0, _defineProperty2.default)({}, levelsArray[2], (0, _defineProperty2.default)({}, levelsArray[1], (0, _objectSpread2.default)({}, filters)));
      }

      _newObject[levelsArray[2]][levelsArray[1]][levelsArray[0]] = 1;
      return (0, _objectSpread2.default)({}, _newObject);
    }
  };

  var deleteFilter = function deleteFilter(rout) {
    var levelsArray = rout.includes("|") ? rout.split("|").reverse() : [rout];
    var newObject = (0, _objectSpread2.default)({}, globalFilters);
    if (levelsArray.length === 1) delete newObject[levelsArray[0]];else if (levelsArray.length === 2) delete newObject[levelsArray[1]][levelsArray[0]];else if (levelsArray.length === 3) delete newObject[levelsArray[2]][levelsArray[1]][levelsArray[0]];
    return newObject;
  };

  var onChangeChk = function onChangeChk(e, object) {
    var idsFilter = returnFilterId(object);

    if ((0, _typeof2.default)(idsFilter) === "object") {
      idsFilter = oneDimensionArray(idsFilter);
    } else {
      idsFilter = [idsFilter];
    }

    var tempArray = parameterArray.slice();

    if (e.target.checked) {
      var _tempArray;

      var newFilter = createFilter(route, option, activeFilters);

      (_tempArray = tempArray).push.apply(_tempArray, (0, _toConsumableArray2.default)(idsFilter));

      setActiveFilters(function (current) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, current), newFilter);
      });
    } else {
      tempArray = tempArray.filter(function (element) {
        return !idsFilter.includes(element);
      });
      var remainFilters = deleteFilter(route, globalFilters);
      setActiveFilters(function (current) {
        return remainFilters;
      });
    }

    setParameterArray(tempArray);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    mainDivClass: className,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: className,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.CheckBox, {
        id: "main-item-" + (id ? id + "-" : "") + option.id + "-" + option.name,
        label: option.name,
        checked: activeFilters[option.name],
        defaultChecked: activeFilters[option.name],
        onChange: function onChange(e) {
          return onChangeChk(e, option);
        }
      }), option.subOptions && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        onClick: function onClick() {
          return setShowSubOptions(!showSubOptions);
        },
        className: "arrow-item",
        children: "\u25C0"
      })]
    }), showSubOptions && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "sub-options",
      children: option.subOptions.map(function (subOption, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomSelectItem, {
          option: subOption,
          id: id,
          className: "sub-option",
          route: "".concat(filterRoute, "|").concat(subOption.name),
          activeFilters: activeFilters[option.name],
          parameterArray: parameterArray,
          globalFilters: globalFilters,
          setActiveFilters: setActiveFilters,
          setParameterArray: setParameterArray
        }, index + (id ? id + "-" : "") + subOption.name);
      })
    })]
  });
};

exports.CustomSelectItem = CustomSelectItem;